module.exports = __webpack_public_path__ + "img/08.366b457b.jpg";